import React from 'react'

const ColorSwatch = ({
  className = '',
  width = '1em',
  height = '1em',
  left = '#202020',
  mid = '#6699CC',
  right = '#F2D6CE',
  ...props
}) => (
  <svg
    className={`ac-icon ac-icon__color-swatch ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 27 11'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path fill={left} d='M5.51 11.02A5.51 5.51 0 1 0 5.51 0a5.51 5.51 0 0 0 0 11.02z' />
    <path fill={mid} d='M11 10.49a5.51 5.51 0 1 0 0-9.95 7.48 7.48 0 0 1 0 9.95z' />
    <path fill={right} d='M19 10.49a5.51 5.51 0 1 0 0-9.95 7.48 7.48 0 0 1 0 9.95z' />
  </svg>
)

export default ColorSwatch
